import { render, staticRenderFns } from "./myAskQuestions.vue?vue&type=template&id=eadece6a&scoped=true"
import script from "./myAskQuestions.vue?vue&type=script&lang=js"
export * from "./myAskQuestions.vue?vue&type=script&lang=js"
import style0 from "./myAskQuestions.vue?vue&type=style&index=0&id=eadece6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadece6a",
  null
  
)

export default component.exports